<template>
  <div class="status-c">
    <fm-title title-text="动作" :title-menus="[{key: 'add', label: '新增'}]" @clickTitleMenu="clickTitleMenu">
    </fm-title>
    <div class="c-table">
      <fm-table-new
        :columns="columns"
        :auto-height="true"
        ref="table"
        :data-list="actionList"
        emptyPlaceholder="-">
        <table-actions slot="actions" @table-action="tableAction" slot-scope="{ row }" :data="tableActions" :row="row"></table-actions>
      </fm-table-new>
    </div>
    <fm-modal v-model="openCondition" width="800" v-if="openCondition">
      <div style="width: 100%;height: 70vh">
      <condition
        :data-source-keys="dataSourceKeys"
        :action-label="chooseData.statusLabel + ' ' + chooseData.label"
        :user-source-keys="userSourceKeys"
        @dataUpdate="$emit('dataUpdate')"
        action-type="status_action"
        :action-id="chooseData.id"
        :condition-list="chooseData.conditionList"></condition>
      </div>
    </fm-modal>
    <fm-form-dialog
      form-title="动作"
      :open-dialog.sync="openDialog"
      :form-parms="formParms"
      :old-data="chooseData"
      :mask-closable="false"
      label-alone
      label-align="left"
      form-width="800px"
      @formSubmit="formSubmit"
      @handleClose="openDialog = false">
    </fm-form-dialog>
  </div>
</template>

<script>
import TableActions from '@/components/base/TableActions'
import Condition from './condition'

import {
  statusManageRequest
} from '../../api'

export default {
  components: {
    TableActions,
    Condition
  },
  props: {
    statusGroupId: { type: Number },
    statusList: { type: Array},
    actionList: { type: Array},
    dataSourceKeys: { type: Array},
    userSourceKeys: { type: Array}
  },
  data () {
    return {
      chooseData: null,
      openCondition: false,
      openDialog: false
    }
  },
  watch: {
    actionList: {
      deep: true,
      handler () {
        let data = this.chooseData && this.chooseData.id ? this.actionList.find(v => v.id === this.chooseData.id) : null
        this.chooseData = data ? Object.assign({}, data) : {}
      },
      immediate: true
    }
  },
  computed: {
    formParms () {
      return [{
        type: 'select',
        label: '状态',
        key: 'statusId',
        selectDatas: this.statusList.map(v => {
          return {
            key: v.id,
            label: v.label
          }
        }),
        check: {
          required: true
        }
      },
      {
        type: 'input',
        label: '动作',
        key: 'label',
        check: {
          required: true
        }
      },
      {
        type: 'input',
        label: 'KEY',
        key: 'actionKey',
        check: {
          required: true
        }
      }]
    },
    tableActions () {
      return [{
        key: 'condition',
        label: '条件'
      },
      {
        key: 'edit',
        label: '修改'
      },
      {
        key: 'del',
        label: '删除'
      }]
    },
    columns () {
      return [{
        field: 'label',
        title: '动作'
      },
      {
        field: 'actionKey',
        title: 'KEY'
      },
      {
        field: 'statusLabel',
        title: '状态'
      },
      {
        title: '操作',
        field: 'actions',
        slot: 'actions',
        width: 60,
        fixed: 'right',
        search: false,
        export: false
      }]
    }
  },
  methods: {
    async formSubmit (data, resolve) {
      if (data.id) {
        await statusManageRequest.updateAction(data)
      } else {
        data.statusGroupId = this.statusGroupId
        await statusManageRequest.addAction(data)
      }
      this.openDialog = false
      this.$emit('dataUpdate')
      resolve()
    },
    async tableAction (parm) {
      this.chooseData = Object.assign({}, parm.data)
      if (parm.action === 'condition') {
        this.openCondition = true
      } else if (parm.action === 'edit') {
        this.openDialog = true
      } else {
        const result = await this.$dialog.confirm({title: '系统提示', content: '确定删除该动作吗?'})
        if (result) {
          await statusManageRequest.delAction(this.chooseData.id)
          this.$emit('dataUpdate')
        }
      }
    },
    clickTitleMenu () {
      this.chooseData = {}
      this.openDialog = true
    }
  }
}
</script>

<style scoped lang="less">
.status-c {
  width: 100%;
  height: 100%;
}
.c-table {
  width: 100%;
  height: calc(100% - 48px);
}
</style>